import { render, staticRenderFns } from "./LessonsRatingView.vue?vue&type=template&id=0a00d764"
import script from "./LessonsRatingView.vue?vue&type=script&lang=js"
export * from "./LessonsRatingView.vue?vue&type=script&lang=js"
import style0 from "./LessonsRatingView.vue?vue&type=style&index=0&id=0a00d764&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports